/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */
import { get, writable } from 'svelte/store';
import { breakpoints } from '@oat-sa-private/ui-identity';

const BUTTON_FULL_SHAPE = 'pill';
const BUTTON_REDUCED_SHAPE = 'circular';
const WIDTH_THRESHOLD = breakpoints.width.medium;

function createStore() {
    const store = writable({
        full: true,
        pageWidth: window.innerWidth,
        widthThreshold: WIDTH_THRESHOLD,
        buttonShape: BUTTON_FULL_SHAPE
    });
    const { subscribe, set, update } = store;

    const applyThreshold = (pageWidth, widthThreshold) => {
        const full = pageWidth > widthThreshold;
        const buttonShape = full ? BUTTON_FULL_SHAPE : BUTTON_REDUCED_SHAPE;
        return { full, pageWidth, widthThreshold, buttonShape };
    };

    return {
        subscribe,

        get() {
            return get(store);
        },

        setWidthThreshold(widthThreshold) {
            set(applyThreshold(window.innerWidth, widthThreshold));
        },

        setPageWidth(pageWidth) {
            update(data => applyThreshold(pageWidth, data.widthThreshold));
        }
    };
}

export default createStore();
